import { normalizeTemaHash } from "./resolveTemaRoute";
import { prefetchTemaRoute } from "./prefetchTemaRoute";

export function applyHashNavigation(path) {
  const nextHash = normalizeTemaHash(path);
  if (window.location.hash === nextHash) {
    return;
  }

  prefetchTemaRoute(nextHash);
  window.location.hash = nextHash === "#" ? "" : nextHash;
}
